const liveRegion = document.getElementById('globalStatusLiveRegion');
export const announceAssistiveStatus = (message, options = {}) => {
  if (!liveRegion) return;
  // Clear previous message to ensure screen readers detect the change
  liveRegion.textContent = '';

  if (options.assertive) {
    // Temporarily go assertive, forces announcement
    liveRegion.setAttribute('aria-live', 'assertive');
    setTimeout(() => {
      liveRegion.textContent = message;
      // Restore polite after announcement
      setTimeout(() => {
        liveRegion.setAttribute('aria-live', 'polite');
      }, 1000); // give time for announcement
    }, 10); // This small wait, helps the screen reader have enough time, to notice and actually speak the message.
  } else {
    setTimeout(() => {
      liveRegion.textContent = message;
    }, 10); // This small wait, helps the screen reader have enough time, to notice and actually speak the message.
  }
};
